import { render, staticRenderFns } from "./PropertyMeta.vue?vue&type=template&id=9863c4c2&scoped=true&"
import script from "./PropertyMeta.vue?vue&type=script&lang=js&"
export * from "./PropertyMeta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9863c4c2",
  null
  
)

export default component.exports